import * as R from 'ramda';
import { createSelector } from 'reselect';
import { selectors } from 'ducks/settings';

const getContentTags = createSelector(
  selectors.data,
  R.prop('contentTags'),
);

export default getContentTags;
